<template>
  <li class="nav__top__login" :class="containerClass">
    <a :href="loginUrl" class="login-href" data-view="login-container" @click.prevent="toggleClicked">Log in</a>
    <div class="nav__top__login-form">
      <form class="login-form" @submit.prevent="formSubmitted()">
        <h4>Log into Backoffice</h4>
        <input name="storename" type="text" placeholder="Store Name" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" v-model="storeName">
        <button id="backoffice-login-submit" for="login-submit">Log in</button>
      </form>
    </div>
  </li>
</template>

<script>
import boUrl from '../../twig/helpers/boUrl';
import cookies from '../../twig/helpers/cookies';

export default {
    props: {
      loginUrl: {
        type: String,
        required: true
      },
    },
    data(){
        return {
          isActive: false,
          storeName: '',
        };
    },
    computed: {
      containerClass(){
        return {
          'nav__top__login--active': this.isActive,
        };
      },
    },
    methods: {
      toggleClicked(){
        this.isActive = !this.isActive;
        cookies.setLoginCookie();
      },
      formSubmitted(){
        dataLayer.push({ event: 'login', account: this.storeName });
        const root = boUrl.url();
        const subdomain = this.storeName;
        const url = subdomain ? `${root.slice(0, 8)}${subdomain}.${root.slice(8)}` : root;
        window.location = url;
      },
    }
};
</script>